<div class="modal-header p-3 pb-0 d-flex align-items-center justify-content-between">

    <div *ngIf="title || subtitle" class="modal-header-text">
        <h4 *ngIf="title" class="modal-title mb-1 text-truncate" [title]="title">
            {{ title }}
        </h4>
        <small *ngIf="subtitle" class="text-muted d-block text-truncate" [title]="subtitle">
            {{ subtitle }}
        </small>
    </div>

    <div class="flex-shrink-0">
        <ng-content select=".modal-tools"></ng-content>
        <app-button *ngIf="dismissable" buttonType="icon" size="lg" cssClass="text-dark" [icon]="getIcon('close')"
            (onClick)="close()"></app-button>
    </div>

</div>

<div class="modal-top">
    <ng-content select=".modal-top"></ng-content>
</div>

<div class="modal-body" [ngClass]="{ 'px-0': noBodyPadding }" [class]="'pt-' + bodyPaddingTop">
    <ng-content select=".modal-body-content"></ng-content>
</div>

<div class="modal-footer p-3 pt-0" *ngIf="showActions">
    <ng-content select=".modal-actions"></ng-content>
</div>
